// extracted by mini-css-extract-plugin
export default {"wrapper":"radioBox_wrapper__dIfxI","radio":"radioBox_radio__rVnrF"};